/**
 * @file
 * Loader
 */

import classnames from 'classnames';
import * as React from 'react';

import './loader.css';

export enum LoaderColors {
  LIGHT = 'light',
  DARK = 'dark',
}

interface IProps {
  color?: LoaderColors;
  loading?: boolean;
}

const Loader: React.FC<IProps> = ({ loading, color }) => (
  <>
    {loading && (
      <div className="loader" data-testid="loader">
        <div
          className={classnames('loader__icon', {
            'loader__icon-dark': color === LoaderColors.DARK,
            'loader__icon-light': color === LoaderColors.LIGHT,
          })}
          data-testid="loader-icon"
        />
      </div>
    )}
  </>
);

Loader.defaultProps = {
  color: LoaderColors.DARK,
  loading: true,
};

export default Loader;
